/**
 * Вход в систему. Отдельный экран без шапки приложения: логин и пароль → JWT в httpOnly cookie.
 * После успеха возвращаемся туда, откуда пришли (RequireRole кладёт адрес в `state.from`).
 */

import { useEffect, useState } from 'react';
import type { FormEvent } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { useAuth } from '../auth/AuthContext';
import { FormError, errorMessage } from '../components/ErrorState';

export default function LoginPage() {
    const { status, login, loginPending, loginError } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();
    const from = (location.state as { from?: string } | null)?.from ?? '/';

    const [loginName, setLoginName] = useState('');
    const [password, setPassword] = useState('');
    const [localError, setLocalError] = useState('');

    useEffect(() => {
        if (status === 'authenticated') navigate(from, { replace: true });
    }, [status, from, navigate]);

    const onSubmit = (event: FormEvent<HTMLFormElement>) => {
        event.preventDefault();
        if (!loginName.trim() || !password) {
            setLocalError('Введите логин и пароль');
            return;
        }
        setLocalError('');
        void login(loginName.trim(), password).catch(() => {
            /* текст ошибки берём из loginError */
        });
    };

    return (
        <div className="app-container auth-card">
            <header className="app-header">
                <div className="logo-area">
                    <span className="logo-icon" aria-hidden="true">
                        🏛️
                    </span>
                    <div className="org-name">
                        Обращения граждан
                        <small>Департамент здравоохранения · Система обращений граждан</small>
                    </div>
                </div>
            </header>

            <main className="app-content">
                <div className="page-header">
                    <h1>Вход в систему</h1>
                </div>

                <form className="form-grid" onSubmit={onSubmit}>
                    <label className="form-field">
                        <span>Логин</span>
                        <input
                            className="form-input"
                            type="text"
                            name="login"
                            autoComplete="username"
                            autoFocus
                            value={loginName}
                            onChange={(event) => setLoginName(event.target.value)}
                        />
                    </label>

                    <label className="form-field">
                        <span>Пароль</span>
                        <input
                            className="form-input"
                            type="password"
                            name="password"
                            autoComplete="current-password"
                            value={password}
                            onChange={(event) => setPassword(event.target.value)}
                        />
                    </label>

                    <FormError>{localError || (loginError ? errorMessage(loginError) : '')}</FormError>

                    <div className="form-actions">
                        <button type="submit" className="act-btn primary" disabled={loginPending}>
                            {loginPending ? 'Проверяем…' : 'Войти'}
                        </button>
                    </div>
                </form>

                <p className="footer-note">
                    Доступ выдаёт администратор клиники. Роль и права определяются учётной записью.
                </p>
            </main>
        </div>
    );
}
